// Shamelessly sourced from onboard-frontend
// eslint-disable-next-line import/default
import FieldKit from 'field-kit';
const AU_LANDLINE_DELIMITER_MAP = {
  0: '(',
  3: ')',
  4: ' ',
  9: ' '
};
const AU_MOBILE_DELIMITER_MAP = {
  4: ' ',
  8: ' '
};
const AU_MOBILE_PREFIXES = new Set(['04', '05']);
class AuPhoneNumberFormatter extends FieldKit.PhoneFormatter {
  // @override
  constructor() {
    super();
    this.maximumLength = 14;
  }

  /**
   * Note: mutates `change` param in order to reformat between landline/mobile
   * @override
   */
  isChangeValid(change, error) {
    const valid = super.isChangeValid(change, error);
    const wasMobile = this.isMobile(change.current.text);
    const willBeMobile = this.isMobile(change.proposed.text);
    if (wasMobile !== willBeMobile) {
      change.proposed.text = this.format(this.removeDelimiterMapChars(change.proposed.text));

      // handle cursor change from addition/removal from multiple regions
      const move = (change.proposed.text.match(/[ ()]/g) || []).length - (change.current.text.match(/[ ()]/g) || []).length;
      change.proposed.selectedRange.start += move;
    }
    return valid;
  }

  // @override
  guessFormatFromText(text) {
    if (this.isMobile(text)) {
      this.delimiterMap = AU_MOBILE_DELIMITER_MAP;
      this.maximumLength = 12;
    } else {
      this.delimiterMap = AU_LANDLINE_DELIMITER_MAP;
      this.maximumLength = 14;
    }
  }
  isMobile(text) {
    return text && AU_MOBILE_PREFIXES.has(this.removeDelimiterMapChars(text).slice(0, 2));
  }
}
export default AuPhoneNumberFormatter;